import GenericCreateForm from "../../components/GenericCreateForm";

function CreateBrand() {
  return (
    <GenericCreateForm
      title="Cliente"
      endpoint="/clients"
      backTo="/clients"
    />
  );
}

export default CreateBrand;
